import React, { useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import cx from '@/utils/cx';
import useStyle from './style';

const Tooltip = ({
  children,
  content,
  position,
  arrowSize,
  offset,
  backgroundColor,
  visibility,
  timeout,
  onVisibilityChange,
  tooltipProps,
  ...rest
}) => {
  const classes = useStyle({
    arrowSize, position, backgroundColor, offset,
  });

  useEffect(() => {
    let setTimeoutId;
    if (visibility) {
      setTimeoutId = setTimeout(() => {
        onVisibilityChange(false);
      }, timeout);
    }
    return () => clearTimeout(setTimeoutId);
  }, [visibility]);

  return (
    <div
      className={classes.tooltipWrapper}
      {...rest}
    >
      <div
        className={cx(classes.tooltip, visibility && 'visible', position)}
        _padding_x="md"
        _padding_y="sm"
        _text_color="background"
        _text_size="sm"
        _radius="sm"
        {...tooltipProps}
      >
        {content}
      </div>
      {children}
    </div>
  );
};

Tooltip.propTypes = {
  content: PropTypes.any.isRequired,
  children: PropTypes.node,
  position: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  arrowSize: PropTypes.number,
  offset: PropTypes.number,
  timeout: PropTypes.number,
  backgroundColor: PropTypes.string,
  visibility: PropTypes.bool,
  onVisibilityChange: PropTypes.func,
};

Tooltip.defaultProps = {
  children: null,
  position: 'top',
  arrowSize: 5,
  offset: 0,
  backgroundColor: 'text',
  visibility: false,
  timeout: 10000,
  onVisibilityChange: () => {},
};

export default memo(Tooltip);
